<template>
  <div id="principal">
    <span
      v-if="na"
      class="na-grid-cell"
    >
      N/A
    </span>

    <span
      v-else-if="value == '#NREF#'"
      class="nref-grid-cell"
    >⠀</span>

    <span v-else>{{ value }}</span>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DateCopCellRenderer',
  data () {
    return {
      value: ''
    }
  },
  computed: {
    na () {
      return this.params.data.na
    }
  },
  beforeMount () {
    let format = ''
    if (this.params.value) {
      const mt1 = this.params.value.match(/^\d\d\/\d\d\/\d\d\d\d$/g)
      const mt2 = this.params.value.match(/^\d\d\/\d\d\/\d\d$/g)
      if (mt1) format = 'DD/MM/YYYY'
      if (mt2) format = 'DD/MM/YY'

      this.value = moment(this.params.value, format).toDate().toLocaleDateString()
    } else {
      this.value = null
    }
  }
}
</script>

<style scoped>
div#principal {
  width: 100%;
}
span.na-grid-cell,
span.nref-grid-cell {
  display: block;
  text-align: center;
  position: relative;
  z-index: 6;
  margin: 0 auto;
  right: 17px;
  height: 100%;
  width: calc(100% + 17px + 17px);
  font-weight: 700;
}

span.nref-grid-cell {
  background: #2a2a2acb;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/cop/DateCopCellRenderer.vue